import { useDispatch, useSelector } from "react-redux";
import { changeInvoiceToInfo, fetchInvoiceParams } from "../Reducers/balance";
import { message } from "antd";

const useUpdateCustomerSettings = () => {
  const dispatch = useDispatch();
  const { payload } = useSelector((state) => state.balance.getParams);

  const updatePayload = (updatedFields, data, customerId) => {

    console.log(`UPD FIELDS 1: ${JSON.stringify(updatedFields)}`)
    console.log(`UPD FIELDS 2: ${JSON.stringify(data)}`)
    console.log(`UPD FIELDS 3: ${JSON.stringify(payload)}`)

    const submitData = payload === null ? data : payload
    
    const newPayload = {
      ...payload,
      ...updatedFields,
      orderEmail: updatedFields.orderEmail || submitData.orderEmail || [],
      invoiceTo: updatedFields.invoiceTo || submitData.invoiceTo || [],
    };

    dispatch(changeInvoiceToInfo(newPayload, customerId))
      .then(() => {
        message.success(`Successfully updated!`);
        dispatch(fetchInvoiceParams())
      })
      .catch((err) => {
        message.error(`Failed to update: ${err}`);
      });
  };

  return updatePayload;
};

export default useUpdateCustomerSettings;
